import Api from "@/utils/api";

const state = {
  admins: [],
  admin: {},
  adminRoles: [],
  adminLesson: [],
  admin_assets: [],
};
const getters = {
  getAdmins(state) {
    return state.admins;
  },
  getAdmin(state) {
    return state.admin;
  },
  getAdminLesson(state) {
    return state.adminLesson;
  },
  getAdminAssets(state) {
    return state.admin_assets;
  },
};
const mutations = {
  setAdminRoles(state, data) {
    let format = data.map((role) => {
      return {
        text: role.display_name,
        value: role.id,
      };
    });
    state.adminRoles = format;
  },
  setAdmins(state, data) {
    return (state.admins = data);
  },
  setAdmin(state, data) {
    return (state.admin = data);
  },
  addAdmin(state, data) {
    return (state.admins = state.admins.concat(data));
  },
  setAdminLessons(state, data) {
    return (state.adminLesson = data);
  },

  setAdminAssets(state, data) {
    return (state.admin_assets = data);
  },
};
const actions = {
  async createAdmin({ commit }, payload) {
    let res = await Api.post("/admin/create", payload, true);
    return res;
  },
  async createTenant({ commit }, payload) {
    let res = await Api.post("/tenant", payload, true);
    return res;
  },
  async fetchAdminRoles({ commit }) {
    let res = await Api.get("roles/fetch-roles", true);
    commit("setAdminRoles", res.data.data.roles);
  },
  async fetchAdmins({ commit }) {
    let res = await Api.get("/admin/list", true);
    if (res.status === 200 || res.status === 201) {
      commit("setAdmins", res.data.admins);
      return true;
    } else {
      return res;
    }
  },
  async fetchSingleAdmin({ commit }, payload) {
    let { id } = payload;
    let res = await Api.get(`/admin/${id}/show`, true);
    if (res.status === 200 || res.status === 201) {
      //console.log({ resddd: res.data.data.user });
      commit("setAdmin", res.data.data.user);
      return true;
    } else {
      return res;
    }
  },
  async editAdmin({ commit }, payload) {
    let res = await Api.post(`/admin/${payload.id}/update`, payload, true);
    //console.log({ res });
    if (res.status === 200 || res.status === 201) {
      commit("setAdmin", res.data.data.user);
      return true;
    } else {
      return res;
    }
  },
  async deleteAdmin({ commit }, id) {
    let res = await Api.delete(`/tenant/${id}`, true);

    return res;
  },
  async updateAdminPermission({}, data) {
    let { id, payload } = data;
    let res = await Api.post(
      `/admin/${id}/assign-permissions`,
      { permissions: payload },
      true
    );
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },
  async adminCreateLesson({ commit }, payload) {
    let { lesson } = payload;
    lesson.skills_gained = "programming, development and art &design";
    lesson.lesson_type = "video";
    let res = await Api.post(`/admin/lessons/create`, lesson, true);
    if (res.status === 200 || res.status === 201) {
      // commit("addTenantCourse", res.data.data.course);
      return true;
    } else {
      return res;
    }
  },
  async adminFetchLesson({ commit }) {
    let res = await Api.get(`/admin/lessons/fetch-lessons`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setAdminLessons", res.data.data.data.lessons.data);
      return true;
    } else {
      return res;
    }
  },

  async adminCreateAsset({ commit }, payload) {
    let res = await Api.post(`/admin/asset/upload`, payload, true);
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },
  async fetchAdminAssets({ commit }) {
    let res = await Api.get(`/admin/asset/fetch`, true);
    if (res.status === 200 || res.status === 201) {
      commit("setAdminAssets", res.data.data.assets);
      return true;
    } else {
      return res;
    }
  },
  async deleteAdminAsset({}, payload) {
    let res = await Api.delete(`/admin/asset/${payload.id}/delete`, true);
    return res;
  },
  async updatePassword({ commit }, payload) {
    let res = await Api.post("/changePassword", payload, true);
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return res;
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
